import { PhotosTab } from "./photos-tab";

import type { FC } from "react";

export const VectorTab: FC<{
  onImageClick?: (imageUrl: string) => void;
  selectedImage: string | null;
  onSelectionChange?: (hasSelection: boolean) => void;
  hidden?: boolean;
}> = (props) => (
  <PhotosTab endpoint="/photos/vector" placeholder="Search curated images" {...props} />
);
